/* eslint-disable flowtype/type-id-match */
/* eslint-disable camelcase */
/* @flow strict */

import * as React from 'react';
import { DefaultContainerContext } from '/client/src/contexts/defaultContainer';
import Switcher from '/client/src/components/switcher';
import SimpleSelect from '/client/src/components/forms/select';
import SimpleInput from '/client/src/components/forms/simpleInput';
import { GET, POST } from '/client/src/api';
import './styles.scss';

type PropsType = {
    eventId: number | string
};
type BadgeSettings = {
    custom_badge_label: string,
    event_id: string | number,
    has_additional_ques: boolean,
    has_custom_badge_label: boolean,
    id: string | number,
    is_iosenabled: boolean,
    question_label: string
};

const ADDITIONAL_QUESTIONS = [
    {
        value: 'What is your favorite movie?',
        label: 'What is your favorite movie?'
    },
    {
        value: 'What was your childhood nickname?',
        label: 'What was your childhood nickname?'
    },
    {
        value: 'What is the name of your favorite childhood friend?',
        label: 'What is the name of your favorite childhood friend?'
    },
    {
        value: 'In what city or town did your mother and father meet?',
        label: 'In what city or town did your mother and father meet?'
    },
    {
        value: 'What is the middle name of your oldest child?',
        label: 'What is the middle name of your oldest child?'
    }
];

const EventBadgePrintingSettings = ({ eventId }: PropsType): React.Element<'div'> => {
    const context = React.useContext(DefaultContainerContext);
    const [isLoading, setLoading] = React.useState(false);
    const [customBadgeLabel, setCustomBadgeLabel] = React.useState(null);
    const [showCustomBadgeLabelSubmitButton, setShowCustomBadgeLabelSubmitButton] = React.useState(false);
    const [settings, setSettings] = React.useState({
        custom_badge_label: '',
        event_id: eventId,
        has_additional_ques: false,
        has_custom_badge_label: false,
        id: null,
        is_iosenabled: false,
        question_label: ''
    });

    React.useEffect(() => {
        init();
    }, []);

    const init = async () => {
        try {
            setLoading(true);
            const { result } = await GET(`/api/v1/1/events/${eventId}/BadgeSetting`);

            setSettings(result);
            setCustomBadgeLabel(result.custom_badge_label);
            setLoading(false);
        } catch (e) {
            setLoading(false);
            console.log(e);
        }
    };

    const handleSettingsChange = async (
        {
            custom_badge_label,
            event_id,
            has_additional_ques,
            has_custom_badge_label,
            id,
            is_iosenabled,
            question_label
        }: BadgeSettings) => {
        setLoading(true);
        try {
            const { result } = await POST(`/api/v1/1/events/${eventId}/BadgeSetting`, {
                custom_badge_label,
                event_id,
                has_additional_ques,
                has_custom_badge_label,
                id,
                is_iosenabled,
                question_label
            });

            setSettings(result);
            setShowCustomBadgeLabelSubmitButton(false);
            setLoading(false);
        } catch (e) {
            context.handleShowSystemDialog(true, {
                systemDialogType: 'error',
                systemDialogTitle: 'Oops!',
                systemDialogContent: 'Can\'t update'
            });
            setLoading(false);
            console.log(e);
        }
    };

    const handleCustomBadgeLabel = (val: string) => {
        setShowCustomBadgeLabelSubmitButton(true);
        setCustomBadgeLabel(val);
    };

    return (
        <div className='panel' style={{ padding: '15px 10px' }}>
            <div className='badge-printing-settings'>
                {isLoading && <div className='csspinner' />}
                <h5>
                    Enable badge printing to add an option to print badges using the Sparxo iPad app.
                    Downloaded Guestlist Check-in by Sparxo from the iTunes Store on your iPad and set up a compatible printer.
                    The option to print badges appears in two places: after the guest is checked in using check-in and after
                    the purchase is complete using POS.
                </h5>
                <div className='badge-printing-settings_container'>
                    <section>
                        <div className='badge-printing-settings_item'>
                            <span className='key'>Enable badge printing on IOS check-in app</span>
                            <span className='value'>
                                <Switcher
                                  className='form-switcher pull-left'
                                  checked={settings.is_iosenabled}
                                  id={1}
                                  index={1}
                                  onCallback={() => {
                                        handleSettingsChange({
                                            ...settings,
                                            is_iosenabled: !settings.is_iosenabled
                                        });
                                    }}
                                />
                            </span>
                        </div>
                    </section>
                    <section>
                        <div className='badge-printing-settings_item'>
                            <span className='key'>Print additional question answer on badge</span>
                            <span className='value'>
                                <Switcher
                                  className='form-switcher pull-left'
                                  checked={settings.has_additional_ques}
                                  id={2}
                                  index={2}
                                  onCallback={() => {
                                        handleSettingsChange({
                                            ...settings,
                                            has_additional_ques: !settings.has_additional_ques
                                        });
                                    }}
                                />
                            </span>
                        </div>
                        <div className='badge-printing-settings_hint'>
                            The answer to the additional question selected will be printed on the badge.
                            This question will be added to the POS.
                        </div>
                        <div>
                            <SimpleSelect
                              value={settings.question_label}
                              label='Additional question'
                              callBack={(e: any) => {
                                    handleSettingsChange({
                                        ...settings,
                                        question_label: e.target.value
                                    });
                                }}
                              items={ADDITIONAL_QUESTIONS}
                            />
                        </div>
                    </section>
                    <section>
                        <div className='badge-printing-settings_item'>
                            <span className='key'>Add custom badge label</span>
                            <span className='value'>
                                <Switcher
                                  className='form-switcher pull-left'
                                  checked={settings.has_custom_badge_label}
                                  id={3}
                                  index={3}
                                  onCallback={() => {
                                        handleSettingsChange({
                                            ...settings,
                                            has_custom_badge_label: !settings.has_custom_badge_label
                                        });
                                    }}
                                />
                            </span>
                        </div>
                        <div className='badge-printing-settings_hint'>
                        Add badge labels by entering labels separated by a comma.
                            (e.g VIP, GENERAL ADMISSION, STAFF)
                        </div>
                        <div>
                            <div className='custom-badge'>
                            <SimpleInput
                              name={'custom-badge'}
                              id={'custom-badge'}
                              placeholder='Company name'
                              value={customBadgeLabel}
                              onChange={(e: {}): void => handleCustomBadgeLabel(e.target.value)}
                            />
                            {
                            showCustomBadgeLabelSubmitButton &&
                                <button
                                  className='btn-pink custom-badge-label-submit-btn'
                                  onClick={(): void => handleSettingsChange({
                                        ...settings,
                                        custom_badge_label: customBadgeLabel
                                    })}
                                >Save
                            </button>
                            }
                            </div>
                            <div className='badge-printing-settings_hint'>
                               Only 16 characters are allowed. Separate labels by a comma to build a list.
                            </div>
                        </div>
                    </section>
                </div>
            </div >
        </div >
    );
};

export default EventBadgePrintingSettings;